/* eslint-disable jest/require-hook */
import {
  competitionCalendarResultsWidget,
  competitionPredictedLineupsWidget,
  competitionRankingWidget,
  competitionTopScorersWidget,
  leaguesHomepageWidget,
  matchPredictedLineupsWidget,
  matchReportsDetailsWidget,
  matchReportsWidget,
  menuGliderWidget,
  teamCalendarResultsWidget,
  teamLastNextMatchWidget,
  teamPlayersWidget,
  teamRankingWidget,
  competitionBoardWidget,
  scorersRankingPlayerPageWidget,
} from '@sky-it-livedata/livedata-football-widgets';

/* Import Dynamic Components */
import DynamicCompetitionBoard from './components/competition-board/dynamic-competition-board';
import DynamicCompetitionCalendarResults from './components/competition-calendar-results/dynamic-competition-calendar-results';
import DynamicCompetitionPredictedLineups from './components/competition-predicted-lineups/dynamic-competition-predicted-lineups';
import DynamicCompetitionRanking from './components/competition-ranking/dynamic-competition-ranking';
import DynamicCompetitionTopScorers from './components/competition-top-scorers/dynamic-competition-top-scorers';
import DynamicLeaguesHomepage from './components/leagues-homepage/dynamic-leagues-homepage';
import DynamicMatchPredictedLineups from './components/match-predicted-lineups/dynamic-match-predicted-lineups';
import DynamicMatchReports from './components/match-reports/dynamic-match-reports';
import DynamicMatchReportsDetail from './components/match-reports-detail/dynamic-match-reports-detail';
import DynamicMenuGlider from './components/menu-glider/dynamic-menu-glider';
import DynamicTeamCalendarResults from './components/team-calendar-results/dynamic-team-calendar-results';
import DynamicTeamLastNextMatch from './components/team-last-next-match/dynamic-team-last-next-match';
import DynamicTeamPlayers from './components/team-players/dynamic-team-players';
import DynamicTeamRanking from './components/team-ranking/dynamic-team-ranking';
import DynamicScorersRankingPlayerPage from './components/scorers-ranking-player-page/dynamic-scorers-ranking-player-page';
import { defineWebComponents } from './utils/web-components-utils';
import { checkTabs } from './utils/switch-tabs';
import { competitionBoardStickyContainer } from './utils/competition-board-sticky-container';
import { trackPageViews } from './utils/track-digital-data';
import { hydrateDropdowns } from './utils/hydrate-dropdowns';
import { trackPlayersCards } from './utils/track-players-cards';
import { fallbackPlayerImages } from './utils/player-images';
import TeamTabsWrapperUtils from './utils/team-tabs-wrapper';
import { initPlayerPageAdv } from './utils/init-player-page-adv';

const webComponentsMap = new Map();
webComponentsMap.set(competitionBoardWidget.tag, DynamicCompetitionBoard);
webComponentsMap.set(competitionCalendarResultsWidget.tag, DynamicCompetitionCalendarResults);
webComponentsMap.set(competitionPredictedLineupsWidget.tag, DynamicCompetitionPredictedLineups);
webComponentsMap.set(competitionRankingWidget.tag, DynamicCompetitionRanking);
webComponentsMap.set(competitionTopScorersWidget.tag, DynamicCompetitionTopScorers);
webComponentsMap.set(leaguesHomepageWidget.tag, DynamicLeaguesHomepage);
webComponentsMap.set(matchPredictedLineupsWidget.tag, DynamicMatchPredictedLineups);
webComponentsMap.set(matchReportsDetailsWidget.tag, DynamicMatchReportsDetail); // ISS-6050 - Ex PAGELLE
webComponentsMap.set(matchReportsWidget.tag, DynamicMatchReports); // ISS-6050 - Ex PAGELLE
webComponentsMap.set(menuGliderWidget.tag, DynamicMenuGlider);
webComponentsMap.set(teamCalendarResultsWidget.tag, DynamicTeamCalendarResults);
webComponentsMap.set(teamLastNextMatchWidget.tag, DynamicTeamLastNextMatch);
webComponentsMap.set(teamPlayersWidget.tag, DynamicTeamPlayers); // ISS-6012
webComponentsMap.set(teamRankingWidget.tag, DynamicTeamRanking);
webComponentsMap.set(scorersRankingPlayerPageWidget.tag, DynamicScorersRankingPlayerPage);

defineWebComponents(webComponentsMap);

document.addEventListener('DOMContentLoaded', () => {
  checkTabs();
  competitionBoardStickyContainer();
  hydrateDropdowns({
    tagsToExclude: [
      competitionBoardWidget.tag,
      competitionCalendarResultsWidget.tag,
      competitionPredictedLineupsWidget.tag,
      competitionRankingWidget.tag,
      competitionTopScorersWidget.tag,
      leaguesHomepageWidget.tag,
      matchPredictedLineupsWidget.tag,
      matchReportsDetailsWidget.tag,
      matchReportsWidget.tag,
      menuGliderWidget.tag,
      teamCalendarResultsWidget.tag,
      teamLastNextMatchWidget.tag,
      teamPlayersWidget.tag,
      teamRankingWidget.tag,
      scorersRankingPlayerPageWidget.tag,
    ],
  });
  initPlayerPageAdv();
  trackPlayersCards();
  fallbackPlayerImages();
});

window.addEventListener('load', () => {
  TeamTabsWrapperUtils.init();
});

window.addEventListener('competition_board_loaded', () => {
  trackPageViews();
});
